import { AppNav } from "@/routes/app-nav";
import { TitleService } from "@/services/title.service";
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'accessdenied',
  standalone: false,
    templateUrl: './access-denied-page.component.html',
    styleUrls: ['./access-denied-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
  })
  export class AccessDeniedPageComponent implements OnInit {
  
    constructor( private titleService: TitleService) { }
  
    ngOnInit(): void {
        this.titleService.setTitle(AppNav.AccessDenied.title);
      }
  }
  